import React from "react";
import Skeleton from "react-loading-skeleton";
import "./index.css";

const UserBookingsSkeleton = () => {
  return (
    <div className="dashboardofboxes scheduledashboard">
      {/* -------- Top Filters -------- */}
      <div className="usession-top">
        <div className="sessions-category">
          <Skeleton width={150} height={35} borderRadius={8} />
          <Skeleton width={150} height={35} borderRadius={8} style={{ marginLeft: "10px" }} />
        </div>
        <div className="session-filters">
          <Skeleton width={120} height={35} borderRadius={8} />
          <Skeleton width={120} height={35} borderRadius={8} style={{ marginLeft: "10px" }} />
        </div>
      </div>

      {/* -------- Session Cards (repeat skeletons) -------- */}
      {[1, 2].map((i) => (
        <div className="usession-div" key={i}>
          <div className="usession-table">
            <div className="usession-body">
              <div className="usession-container">
                {/* Therapist avatar + name */}
                <div className="thname-value">
                  <Skeleton circle width={50} height={50} />
                  <div className="name-div" style={{ marginLeft: "12px" }}>
                    <Skeleton width={120} height={18} />
                    <Skeleton width={80} height={14} style={{ marginTop: "5px" }} />
                  </div>
                </div>

                {/* Date + Time */}
                <div className="thsession-value">
                  <Skeleton width={100} height={16} />
                  <Skeleton width={120} height={16} style={{ marginTop: "5px" }} />
                </div>

                {/* Buttons (cancel / reschedule / join) */}
                <div className="ubtns-div">
                  <Skeleton width={80} height={30} borderRadius={6} />
                  <Skeleton width={100} height={30} borderRadius={6} style={{ marginLeft: "10px" }} />
                </div>
              </div>

              {/* Expanded content placeholder */}
              <div className="usession-content" style={{ marginTop: "15px" }}>
                <Skeleton count={2} height={14} />
              </div>

              {/* View more button */}
              <div className="usession-btn-cont">
                <Skeleton width={100} height={25} borderRadius={6} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserBookingsSkeleton;